var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-button"},[_vm._t("default",[_c('label',{directives:[{name:"translate",rawName:"v-translate",value:(_vm.title),expression:"title"}],class:{ checked: _vm.checked }})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }